import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccounting = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 13.85V3.7892M8 3.7892C8 3.7892 9.41844 2.2136 14.2007 2.15005C14.24 2.14955 14.2789 2.15697 14.3153 2.17186C14.3516 2.18675 14.3845 2.20881 14.4122 2.23671C14.4685 2.29334 14.5001 2.37002 14.5 2.44991V11.911C14.5006 11.9888 14.4707 12.0638 14.4167 12.1199C14.3627 12.1759 14.2889 12.2086 14.2111 12.2109C9.4196 12.2756 8 13.85 8 13.85C8 13.85 6.5804 12.2756 1.7889 12.2109C1.71109 12.2086 1.63727 12.1759 1.58327 12.1199C1.52926 12.0638 1.49937 11.9888 1.50001 11.911V2.44991C1.49989 2.37002 1.53148 2.29334 1.58783 2.23671C1.61545 2.20881 1.64841 2.18675 1.68475 2.17186C1.72108 2.15697 1.76004 2.14955 1.7993 2.15005C6.58156 2.2136 8 3.7892 8 3.7892ZM6.26667 7.52626C5.28344 7.19555 4.26227 6.99074 3.22756 6.91671M6.26667 9.95004C5.28344 9.61933 4.26227 9.41451 3.22756 9.34048M9.73333 7.52626C10.7166 7.19555 11.7377 6.99074 12.7724 6.91671M9.73333 9.95004C10.7166 9.61933 11.7377 9.41451 12.7724 9.34048",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAccounting;
